import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export interface StatsData {
  total_authors: number;
  total_videos: number;
  total_tags: number;
  last_7_days: {
    authors: number;
    videos: number;
    tags: number;
  };
  popular_tags: {
    name: string;
    count: number;
  }[];
  top_authors: {
    username: string;
    videos: number;
  }[];
}

export const fetchStats = async (): Promise<StatsData> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/api/stats/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching stats:', error);
    throw error;
  }
};